// @flow
import React from 'react'

import AbstractFormField from './AbstractFormField'
import { Bool } from '../../../Components/_formFields'

import type { DefaultFormFieldState } from './AbstractFormField'
import type { ValidationErrorType } from '../../Types/ValidationError'

type Props = {
  domain: { _type: string },
  enabled?: boolean,
  id: string,
  isPristine?: boolean,
  label: string,
  name: string,
  onChange: (value: boolean) => void,
  prefix: string,
  textMode?: boolean,
  validationErrors: ValidationErrorType,
  value: boolean,
}

export default class CheckboxWithLabel extends AbstractFormField<Props, DefaultFormFieldState> {
  static defaultProps = {
    enabled: true,
    isPristine: false,
    textMode: false,
  }

  render() {
    return <Bool {...this.props} />
  }
}
